import { useNavigate } from 'react-router-dom';
import { Card, PageHeader } from '@/components/ui';
import { Icon } from '@/components/ui/Icon';

// Help links. The guide/videos point at the public docs; "open ticket" routes
// to the agent's own ticket flow (TicketsPage) instead of a dead button.
// Overridable per environment so a domain move doesn't need a code change.
const GUIDE_URL = (import.meta.env.VITE_DOCS_URL as string | undefined) ?? 'https://api.kailai.tech/docs';
const VIDEOS_URL = (import.meta.env.VITE_VIDEOS_URL as string | undefined) ?? 'https://kailai.tech';

export function Help() {
  const navigate = useNavigate();

  return (
    <div className="stack" style={{ padding: 'var(--gap)' }}>
      <PageHeader title="עזרה ותמיכה" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--gap)' }}>
        <Card title="מדריך משתמש">
          <p style={{ color: 'var(--text-2)', fontSize: 'var(--t-sm)' }}>
            <Icon name="book" size={20} color="var(--accent)" /><br />
            תיעוד למשתמש על כל התכונות.
          </p>
          <a className="btn" href={GUIDE_URL} target="_blank" rel="noreferrer">פתח מדריך</a>
        </Card>
        <Card title="סרטוני הדרכה">
          <p style={{ color: 'var(--text-2)', fontSize: 'var(--t-sm)' }}>
            <Icon name="play" size={20} color="var(--info)" /><br />
            ספריית סרטונים בנושאים שונים.
          </p>
          <a className="btn" href={VIDEOS_URL} target="_blank" rel="noreferrer">צפה</a>
        </Card>
        <Card title="פתח טיקט">
          <p style={{ color: 'var(--text-2)', fontSize: 'var(--t-sm)' }}>
            <Icon name="mail" size={20} color="var(--warn)" /><br />
            צוות התמיכה יענה תוך שעות ספורות.
          </p>
          <button type="button" className="btn primary" onClick={() => navigate('/agent/tickets')}>פתח טיקט</button>
        </Card>
      </div>
    </div>
  );
}
